/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Safe_Few_Flamingo_TalkInputs */

const fr_safe_few_flamingo_talk = /** @type {(inputs: Safe_Few_Flamingo_TalkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom d'utilisateur (nom et prénom, ou surnom)`)
};

/**

* @param {Safe_Few_Flamingo_TalkInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const safe_few_flamingo_talk = /** @type {((inputs?: Safe_Few_Flamingo_TalkInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Safe_Few_Flamingo_TalkInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_safe_few_flamingo_talk(inputs)
});